export const BOOKING_STATE = Object.freeze({
    CONFIRMED: 'confirmed',
    UNCONFIRMED: 'unconfirmed',
    DENIED: 'denied',
    CANCELLED: 'cancelled',
    CANCELLED_FULL_REFUND: 'cancelled_full_refund',
    IN_CART: 'in_cart',
    EMPTY: 'empty'
});

export const BOOKING_STATE_COLORS = Object.freeze({
    [BOOKING_STATE.CONFIRMED]: '#dcf6e2',
    [BOOKING_STATE.UNCONFIRMED]: '#aad3fb',
    [BOOKING_STATE.DENIED]: '#feecf0',
    [BOOKING_STATE.CANCELLED]: '#fffaeb',
    [BOOKING_STATE.CANCELLED_FULL_REFUND]: '#fffaeb',
    [BOOKING_STATE.IN_CART]: '#c2c2c2',
    [BOOKING_STATE.EMPTY]: '#c2c2c2'
});

export const BOOKING_STATE_BORDER_COLORS = Object.freeze({
    [BOOKING_STATE.CONFIRMED]: '#05ae8f',
    [BOOKING_STATE.UNCONFIRMED]: '#415cf9',
    [BOOKING_STATE.DENIED]: '#fd4242',
    [BOOKING_STATE.CANCELLED]: '#f6ac04',
    [BOOKING_STATE.CANCELLED_FULL_REFUND]: '#f6ac04',
    [BOOKING_STATE.IN_CART]: '#505050',
    [BOOKING_STATE.EMPTY]: '#505050'
});
